import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { DataLayer } from '@alfa-bank/site-data-layer';

import { MenuBanner } from '../menu-banner';

import { MENU_ITEMS_CONFIG } from './config';
import type { TMainMenu, IDeps } from './models';
import { MainMenu as Component } from './main-menu';
import styles from './styles/styles.css';

export const MainMenu = createWidget<IDeps, TMainMenu>({
    styles,
    MenuBanner,
    DataLayer,
    MENU_ITEMS_CONFIG,
})(Component);
